import { render, staticRenderFns } from "./livePromote.vue?vue&type=template&id=49279a0d&scoped=true&"
import script from "./livePromote.vue?vue&type=script&lang=js&"
export * from "./livePromote.vue?vue&type=script&lang=js&"
import style0 from "./livePromote.vue?vue&type=style&index=0&id=49279a0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49279a0d",
  null
  
)

export default component.exports